import { Component, Inject, NgZone, AfterViewInit, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'src/ngx-blockui/decorators/block-ui.decorator';

declare const $: any;
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { AuthService } from 'src/app/_core/auth.service';

@Component({
    selector: 'app-adyen-dialog',
    templateUrl: './adyen-dialog.component.html',
    styleUrls: ['./adyen-dialog.component.scss'],
    standalone: false
})
export class AdyenDialogComponent {
	@BlockUI() blockUI: NgBlockUI;
	@HostListener('window:message', ['$event'])
	onMessage(e) {
		if (e.data?.adyenPayload) this.applyPayment(e.data );
	}
	title: string = 'EX_PAYMENT_MODAL';

	constructor(
		public appService: AppService,
		public entityService: EntityService,
		private authService: AuthService,
		public dialogRef: MatDialogRef<AdyenDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {

		let enableSaveToWallet = this.appService.user && this.appService.translate('MESSAGES.SAVE_INFO_PAYMENT');
		if (this.data.httpArgs.isPreAuth) {
			this.title = 'add_pm';
		} else if (this.data.isAddToWallet) {
			this.title = 'add_pm';
		} else {
			this.title = 'EX_PAYMENT_MODAL';
			this.data.enableSaveToWallet = this.appService.user && this.appService.translate('MESSAGES.SAVE_INFO_PAYMENT');
		}
		window["ADYENPARAMS"] = this.data;

		this.blockUI.start();
	}

	brandSurcharge;
	applyPayment(e) {

		if(this.data.isAddToWallet) {
			return this.addWalletPayment(e);
		}

		let data = e.adyenPayload;
		if (e.brandSurcharge) this.brandSurcharge = e.brandSurcharge;
		let args = this.data.httpArgs;
		let parsedPayment = {
			isPreAuth: args.isPreAuth,
			...this.data.parsedPayment,
			...{
				paymentProcessId: this.data.args.paymentProcessId,
				amount: this.data.surcharge?.total || this.data.parsedPayment?.amount,
				providerInfo: data
			},
			returnUrl: `${document.location.origin}/assets/adyen/success.html`
		}
		if (this.brandSurcharge) parsedPayment.processingSurchargeAmount = this.brandSurcharge;
		this.blockUI.start();
		parsedPayment.addPaymentMethodToWallet = e.savePaymentInfo === true;

		this.entityService.postPayment(parsedPayment, args.resultOrder, args.releaseOrder).then(res => {
			this.blockUI.stop();
			this.dialogRef.close({ mode: "success", data: args.resultOrder });
		}).catch(err => {
			if (err?.auth3D) {
				try {document.getElementById('add_payment')["contentWindow"].call3DSAction(err.data.action);} catch (e) { }
			} else {
				this.dialogRef.close({ mode: "error", error: err });
			}
			setTimeout(() => { this.blockUI.stop(); }, 500);
		})
	}

	addWalletPayment(e: any) {
		let data = e.adyenPayload;
		let payload = {
			paymentProcessId: this.data.args.paymentProcessId,
			paymentType: "adyen",
			providerInfo: data
		}
		this.blockUI.start();
		this.entityService.post(
			`/online-shopper/customers/current/wallet/payments`,
			payload
		).then(response => {
			this.dialogRef.close(response);
		}).catch(srvErr => {
			let err = srvErr?.error || {}
			if (err.code == '409943' && err.data?.action) {
				try {document.getElementById('add_payment')["contentWindow"].call3DSAction(err.data.action);} catch (e) { }
			} else {
				this.dialogRef.close({ status: "error", error: err });
			}
		}).finally(() => {
			this.blockUI.stop();
		});
	}

	onFrameLoaded(ev) {
		try {
			this.blockUI.stop();
			let _location = ev.currentTarget.contentWindow.location;
			if (_location.href) {
				console.log("Adyen frame loaded: " + _location.href);
			}
		} catch (err) {

		}
	}
}


